import {Stack, Form} from 'react-bootstrap';
import ReactDatetime from 'react-datetime'
import moment, {Moment} from 'moment';
import React, {useState} from 'react';

// workaround to get react class
const Datetime = (ReactDatetime as any).default;
export type SelectedDate = { startDate: Moment; endDate: Moment };

export function DatetimePicker(
    props: { className?: string; initialSelectedDate?: SelectedDate; onChange?: (selectedDate: SelectedDate) => void } = {}
): React.ReactElement {
    const [period, setPeriod] = useState(
        props.initialSelectedDate ||
        ({
            startDate: moment().days(-10),
            endDate: moment(),
        } as SelectedDate)
    );
    const startDateValidation = (current) => {
        return current.isBefore(period.endDate);
    };

    const endDateValidation = (current) => {
        return current.isAfter(period.startDate);
    };

    const handleOnChange = (date: Moment | string, type: string) => {
        if (typeof date !== 'string') {
            period[type] = date;
            setPeriod(period);
            props.onChange(period);
        }
    };

    const renderInput = (props) => {
        return <Form.Control size="sm" style={{width: '156px'}} {...props} />;
    };

    return (
        <Stack className={`flex-grow-0 ${props.className || ''}`}>
            <div className="fw-bold ps-1">Tarih Aralığı:</div>
            <Stack direction="horizontal">
                <Datetime
                    initialValue={period.startDate}
                    isValidDate={startDateValidation}
                    onChange={(date) => handleOnChange(date, 'startDate')}
                    renderInput={renderInput}
                />
                <span className="mx-1">-</span>
                <Datetime
                    initialValue={period.endDate}
                    isValidDate={endDateValidation}
                    onChange={(date) => handleOnChange(date, 'endDate')}
                    renderInput={renderInput}
                />
            </Stack>
        </Stack>
    );
}
